import { object, string } from 'yup';

export const formSchema = object({
    password: string()
        .min(8, 'Las contraseñas deben contener al menos 8 caracteres')
        .required('La contraseña esta vacía'),
    confirmPassword: string()
        .min(8, 'Las contraseñas no coinciden')
        .required('Confirmar contraseña está vacío'),
});
